"use client"
import { createContext, useContext } from "react"

/**
 * Context for field-level warnings from Drools validation.
 * Maps resolved form field paths to warning messages.
 * Consumed by Config form components to render warnings via FormErrorPrompt.
 */
export const FieldWarningsContext = createContext<Record<string, string>>({})

/**
 * Returns the warning message for a given form field path, or undefined if none.
 */
export const useFieldWarning = (name: string): string | undefined => {
  const warnings = useContext(FieldWarningsContext)
  return warnings[name]
}
